// AUTO-GENERATED FILE. DO NOT EDIT BY HAND.
// Run scripts/generate_photos.py to regenerate.

const preshuffle_photos = [
  { src: "/photos/resized/resized_IMG_1338.JPG", width: 800, height: 1200 },
  { src: "/photos/resized/resized_IMG_2771 (2).JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_2774.JPG", width: 800, height: 1200 },
  { src: "/photos/resized/resized_IMG_2840.JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_2851.JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_3155.JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_3210.JPG", width: 800, height: 1200 },
  { src: "/photos/resized/resized_IMG_3491.JPG", width: 800, height: 1200 },
  { src: "/photos/resized/resized_IMG_3557.JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_3645.JPG", width: 800, height: 1200 },
  { src: "/photos/resized/resized_IMG_3657.JPG", width: 800, height: 1200 },
  { src: "/photos/resized/resized_IMG_3972.JPG", width: 800, height: 1200 },
  { src: "/photos/resized/resized_IMG_3979.JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_4030.JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_4033.JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_4132.JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_4140 (2026-06-28T18_40_29.050).JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_4343 (2026-06-28T18_35_33.744).JPG", width: 800, height: 1200 },
  { src: "/photos/resized/resized_IMG_4444.JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_4761.JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_4849 (2026-06-28T18_23_12.958).JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_4969 (2026-06-28T18_20_14.097)(1).JPG", width: 800, height: 1200 },
  { src: "/photos/resized/resized_IMG_5174 (2026-06-28T18_13_55.197).JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_5307 (2026-06-28T18_10_33.455).JPG", width: 800, height: 1200 },
  { src: "/photos/resized/resized_IMG_6311 (2026-07-15T22_45_46.705).JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_6365 (2026-07-15T22_42_29.788).JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_7234 (2026-07-15T22_21_22.258).JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_7836 (2026-07-15T22_07_46.122).JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_8090 (2026-07-15T21_55_03.206).JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_8136 (2026-07-15T21_53_46.971).JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_8207 (2026-07-15T21_52_08.420).JPG", width: 800, height: 1200 },
  { src: "/photos/resized/resized_IMG_8541 (2026-07-15T21_44_32.133).JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_8800 (2026-07-15T22_05_44.286).JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_8821 (2026-07-15T22_05_19.275).JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_8877 (2026-07-15T22_03_59.739).JPG", width: 800, height: 1200 },
  { src: "/photos/resized/resized_IMG_8921.JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_9020.JPG", width: 800, height: 1200 },
  { src: "/photos/resized/resized_IMG_9178.JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_9214.JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_9563.JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_IMG_9583.JPG", width: 800, height: 1200 },
  { src: "/photos/resized/resized_IMG_9641.JPG", width: 1200, height: 800 },
  { src: "/photos/resized/resized_WINTER.jpg", width: 1200, height: 675 },
  { src: "/photos/resized/resized_WINTER2.jpg", width: 1200, height: 675 },
];

function shuffleArray(array) {
  let currentIndex = array.length;
  let randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex !== 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }

  return array;
}
                 
                 const photos = shuffleArray(preshuffle_photos)

export default photos;
